"use strict";

angular.module("vendor")
.component("deliveryScheduleInline", {
    templateUrl: require("./delivery-schedule-inline.component.html"),
    bindings: {
        deliveryRules: "<"
    },
    controller: function($rootScope, $scope, common, Language, POPOVER_POPUP_DELAY) {
        $scope.POPOVER_POPUP_DELAY = POPOVER_POPUP_DELAY;
        Language.initializeScope($scope, "language", "locale");

        var unregisterLanguageChanged = $rootScope.$on("LanguageChanged", function(event, newLocale) {
            setWeekdays(newLocale);
        });

        $scope.$on("$destroy", function() {
            unregisterLanguageChanged();
        });

        function setWeekdays(locale) {
            $scope.weekdays = common.getISOWeekdays(locale);
        }

        setWeekdays($scope.locale);
    }
});



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/delivery-schedule-inline/delivery-schedule-inline.component.js
// module id = 848
// module chunks = 0